import gql from 'graphql-tag';
import { photoFragment, recoPhotoFragment } from './photoFragments';

export const feedFragment = gql`
    ${photoFragment}
    ${recoPhotoFragment}
    fragment feedContent on Feed {
        type
        author {
            id
            name
            headerUrl
            following
            headerUrls {
                url
            }
        }
        photo {
            ...photoContent
            ...recoPhotoFragment
        }
        canAddComment
        llsid
        status
        currentPcursor
        tags {
            type
            name
        }
    }
`;
